export default "__VITE_PUBLIC_ASSET__42fc3450__"